<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFileCog } from "@mdi/js";
export default {
  name: "MdiFileCog",
  data() {
    return {
      svgPath: mdiFileCog,
    };
  },
};
</script>
